(() => {
  if (customElements.get('pa-sticky-atc')) return;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  class PAStickyATC extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(max-width: 749px)');
      this.button = this.querySelector('[data-pa-sticky-action]');
      this.priceOut = this.querySelector('[data-pa-sticky-price]');
      this.pastForm = false;
      // PA Options mode (same detection as pa-product-preview.js): the Globo box is not on the page and is never queried.
      this.paMode = Boolean(document.querySelector('[data-pa-options-picker][data-candidate="true"]'));
      this.onClick = () => this.handleClick();
      this.onMq = () => this.update();
      this.button.addEventListener('click', this.onClick);
      this.mq.addEventListener('change', this.onMq);
      const target = this.submit?.closest('product-form') || this.submit;
      if (target) {
        this.io = new IntersectionObserver(([entry]) => {
          this.pastForm = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.update();
        });
        this.io.observe(target);
      }
      const price = document.getElementById(this.dataset.priceId);
      if (price) {
        this.priceObserver = new MutationObserver(() => this.syncPrice(price));
        this.priceObserver.observe(price, { childList: true, subtree: true, characterData: true });
        this.syncPrice(price);
      }
    }
    disconnectedCallback() {
      this.io?.disconnect(); this.priceObserver?.disconnect();
      this.mq?.removeEventListener('change', this.onMq);
      document.body.classList.remove('pa-sticky-atc-visible');
    }
    get submit() { return document.getElementById(this.dataset.submitId); }
    get form() { return document.getElementById(this.dataset.formId); }
    get options() { return this.paMode ? null : this.form?.querySelector('gpo-container, .gpo-app') || null; }
    syncPrice(price) {
      const el = price.querySelector('.price--on-sale .price-item--sale, .price__regular .price-item--regular');
      if (el && this.priceOut) this.priceOut.textContent = el.textContent.trim();
    }
    update() {
      const submit = this.submit;
      const show = Boolean(this.mq.matches && this.pastForm && submit);
      this.hidden = !show;
      document.body.classList.toggle('pa-sticky-atc-visible', show);
      if (!submit) return;
      const disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      this.button.textContent = disabled ? submit.textContent.trim()
        : (this.options ? this.dataset.labelOptions : this.dataset.labelAdd);
    }
    handleClick() {
      const submit = this.submit;
      if (!submit || submit.disabled) return;
      const behavior = reduced() ? 'auto' : 'smooth';
      const options = this.options;
      if (options) {               // Never submit: Globo validates required options on the real form.
        options.scrollIntoView({ behavior, block: 'start' });
        // Globo hides its swatch radios (display:none), so only a rendered control can take focus; otherwise focus the container.
        const first = Array.from(options.querySelectorAll('input:not([type="hidden"]):not([disabled]), select, textarea, button, [tabindex="0"]'))
          .find((el) => el.getClientRects().length > 0);
        window.setTimeout(() => {
          if (first) { first.focus({ preventScroll: true }); return; }
          if (!options.hasAttribute('tabindex')) options.setAttribute('tabindex', '-1');
          if (!options.hasAttribute('aria-label') && !options.hasAttribute('aria-labelledby')) { options.setAttribute('role', 'group'); options.setAttribute('aria-label', 'Product options'); }
          options.focus({ preventScroll: true });
        }, behavior === 'smooth' ? 450 : 0);
        return;
      }
      submit.scrollIntoView({ behavior, block: 'center' });
      submit.click();             // Same code path as a real click (product-form.js).
    }
  }
  customElements.define('pa-sticky-atc', PAStickyATC);
})();